import { api } from '@/services/api';
import { useQuery } from '@tanstack/react-query';

export interface AccountInviteDetails {
  id: string;
  status: string;
  invited_at: string;
  accepted_at: string | null;
  invited_by_account_id: string | null;
  role: string | null;
  permissions: Record<string, boolean> | string[];
  inviter: {
    name: string | null;
    email: string | null;
    avatar_url: string | null;
  };
  account: {
    name: string;
    logo_url: string | null;
  };
  email: string;
  requires_password_setup: boolean;
  expires_at: string;
}

export const useFetchAccountInvite = (token: string | undefined) => {
  const {
    data: invite,
    error,
    isPending,
  } = useQuery<AccountInviteDetails>({
    queryKey: [`account-invite-${token}`],
    queryFn: async () => {
      const response = await api.get(`/v1/invites/${token}`);
      return response.data?.data ?? response.data;
    },
    enabled: !!token,
    retry: false,
  });

  return { invite, error, isPending };
};
